import {
  useGetIntelligenceKpisPortfolio,
  useGetIntelligenceKpisPortfolioHistory,
} from '../api/kpi-api/kpi-api';
import { PORTFOLIO_KPI_KEYS } from '../components/ReportMetrics/portfolio';
import { KPI } from '../components/ReportMetrics/intelligence';

/** Days of history the Portfolio Health Trend asks for - same window as the project trend line. */
const TREND_WINDOW_DAYS = 30;

const isoDaysAgo = (days: number): string =>
  new Date(Date.now() - days * 86_400_000).toISOString().slice(0, 10);

/**
 * Everything the Portfolio Overview page reads: one row per project the user
 * can see, and the portfolio-wide health trend.
 *
 * Unlike {@link import('./useProjectIntelligence').useProjectIntelligence} this
 * takes no project id - the portfolio crosses project boundaries, and which
 * projects come back is the backend's decision (tenant + membership), never a
 * filter applied here.
 *
 * The rows ask only for the keys the page actually draws. Omitting `keys` would
 * return every project-scope KPI of every project, which is a much larger
 * payload for columns nothing renders.
 */
export const usePortfolioIntelligence = () => {
  const projects = useGetIntelligenceKpisPortfolio({ keys: [...PORTFOLIO_KPI_KEYS] });

  const healthHistory = useGetIntelligenceKpisPortfolioHistory({
    key: KPI.projectHealthScore,
    from: isoDaysAgo(TREND_WINDOW_DAYS),
  });

  return {
    projects: projects.data,
    healthHistory: healthHistory.data,
    isLoading: projects.isLoading,
    // The page still renders its rows if only the trend line failed.
    isError: projects.isError,
    refetch: () => {
      void projects.refetch();
      void healthHistory.refetch();
    },
  };
};
